import React from "react";
import { bookingUrl } from "./meeting";

export default function DirectCalendar() {
  const url = bookingUrl();
  return <div>
    <h3>Agenda tu reunión</h3>
    <p className="fhelp">Si ya llenaste el formulario para obtener más información sobre las franquicias y aún no has agendado una reunión, elige aquí el día y la hora que más te convengan.</p>
    <iframe title="Calendario de reuniones de Melissa Zabala" src={url} className="frq-meeting" loading="lazy" referrerPolicy="no-referrer" />
    <p className="micro">Si el calendario no carga, <a href={url} target="_blank" rel="noreferrer">ábrelo en otra pestaña</a>.</p>
  </div>;
}
